import React from 'react';
import ReactDOM from 'react-dom/client';
import { Navigate, BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.min.css'
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Privacy from '@/Privacy';
import awsconfig from './aws-exports';

const getSubdomain = url => {
	try {
		const { hostname } = new URL(url);
		const domainParts = hostname.split('.');
		// Assuming the last two parts are the main domain (e.g., "example.com")
		if (domainParts.length > 2) {
			return domainParts.slice(0, -2).join('.');
		}
		return ''; // No subdomain present
	} catch (error) {
		console.error('Invalid URL:', error.message);
		return null;
	}
};

// I have the Cognito redirs as an array with the key of Amplify env.
// Amplify tends to use USER_BRANCH for this in their environment variables.
const redirs = awsconfig.oauth.redirectSignIn.split(',');
const redirMap = {
	bfaprod: redirs.find(f => getSubdomain(f) === 'bfa'),
	demo: redirs.find(f => getSubdomain(f) === 'demo'),
	dev: redirs.find(f => getSubdomain(f) === 'dev'),
	ktwo: redirs.find(f => getSubdomain(f) === 'k2'),
	local: redirs.find(f => getSubdomain(f) === ''),
	preview: redirs.find(f => getSubdomain(f) === 'preview'),
	prod: redirs.find(f => getSubdomain(f) === 'prod'),
	qctprod: redirs.find(f => getSubdomain(f) === 'qct'),
	rmprod: redirs.find(f => getSubdomain(f) === 'rm'),
	wcrdev: redirs.find(f => getSubdomain(f) === 'wcr-dev'),
	wcrprod: redirs.find(f => getSubdomain(f) === 'wcr')
};

//console.log('LOCAL_ENV', process.env.LOCAL_ENV);
//console.log('USER_BRANCH', process.env.USER_BRANCH);

const redirKey = process.env.LOCAL_ENV || process.env.USER_BRANCH;

//console.log('redirKey =', redirKey); 
//console.log('redirect URL =', redirMap[redirKey]);

/** Configure Amplify */
Amplify.configure({
	...awsconfig,
	oauth: {
		...awsconfig.oauth,
		redirectSignIn: redirMap[redirKey],
		redirectSignOut: redirMap[redirKey]
	}
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<Router>
		{window.location.hostname === 'privacy.openpath.ai' ? (
			<Routes>
				<Route path="privacy" element={<Privacy showTitle={true} />} />
				<Route path="*" element={<Navigate to={{ pathname: '/privacy', search: location.search }} replace />} />
			</Routes>
		) : (
			<App />
		)}
	</Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
